import { Badge, Button } from '@sandtech-hub-monorepo/ui-kit';

interface Props {
  image: string;
  /** Short status label, e.g. "Available" or "Coming Soon". */
  badge: string;
  title: string;
  subtitle: string;
  bullets: string[];
  ctaLabel: string;
  /** Filled for the path a learner can act on now, outline otherwise. */
  ctaVariant?: 'default' | 'outline';
  /** Shown, but not a path this learner can take. */
  disabled?: boolean;
  onExplore?: () => void;
}

export const ProgramPathCard = ({
  image,
  badge,
  title,
  subtitle,
  bullets,
  ctaLabel,
  ctaVariant = 'outline',
  disabled = false,
  onExplore,
}: Props) => (
  <div className="flex w-full max-w-[727px] flex-col gap-6 rounded-xl border border-border-secondary bg-card p-5">
    <div className="relative h-[260px] overflow-hidden rounded-xl md:h-[293px]">
      <img
        src={image}
        alt={title}
        className="absolute inset-0 h-full w-full object-cover"
      />
      <Badge className="absolute left-4 top-4 rounded-full border-0 bg-accent px-4 py-1.5 text-sm font-normal text-foreground hover:bg-accent">
        {badge}
      </Badge>
    </div>

    <div className="flex flex-col gap-1">
      <h3 className="text-2xl font-semibold text-heading">{title}</h3>
      <p className="text-lg text-foreground">{subtitle}</p>
    </div>

    <ul className="list-disc pl-5 text-foreground">
      {bullets.map((bullet) => (
        <li key={bullet} className="text-base leading-6">
          {bullet}
        </li>
      ))}
    </ul>

    <Button
      variant={ctaVariant}
      // Unpressable when it has nowhere to go, or when this learner cannot
      // take the path. The badge is a marketing label and says nothing
      // about whether the path opens.
      disabled={disabled || !onExplore}
      onClick={onExplore}
      className="h-12 w-fit rounded-full px-8"
    >
      {ctaLabel}
    </Button>
  </div>
);
